import { ATTRIBUTE_TYPES } from '../../../../../features/Attributes/constants';
import { IDictionaryItem } from '../../../../../features/Attributes/state';

export const getDictValue = (item: IDictionaryItem, type: string | number) => {
    switch (ATTRIBUTE_TYPES[Number(type) as keyof typeof ATTRIBUTE_TYPES]) {
        case 'Integer':
        case 'Double':
            return {
                name: item.name,
                value: Number(item.value),
                label: item.label,
                active: item.active,
            };
        default:
            return item;
    }
};
